import { z } from "zod";
import type { StateType } from "@remi/types/state";

const symbilityErrorTypeValues = [
  "MISSING_REQUIRED_FIELDS",
  "COMPANY_ID_NOT_SUPPORTED",
  "INVALID_EXTERNAL_ID",
] as const;

const symbilityErrorTypeSchema = z.enum(symbilityErrorTypeValues);
const SymbilityErrorType = symbilityErrorTypeSchema.enum;
type SymbilityErrorType = z.infer<typeof symbilityErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type SymbilityErrors =
  | {
      errorType: typeof SymbilityErrorType.MISSING_REQUIRED_FIELDS;
      data: {
        insuredFirstName?: string;
        insuredLastName?: string;
        insuredEmail?: string;
        lossAddress?: Address;
        insuredAddress?: Address;
        assignmentTypeCode?: string;
      };
    }
  | {
      errorType: typeof SymbilityErrorType.COMPANY_ID_NOT_SUPPORTED;
      data: { companyId: string };
    }
  | {
      errorType: typeof SymbilityErrorType.INVALID_EXTERNAL_ID;
      data: { externalId: string };
    };

export const symbilityErrorDetails: Record<SymbilityErrorType, ErrorDetails> = {
  [SymbilityErrorType.MISSING_REQUIRED_FIELDS]: {
    sentryDescription: "Invalid external service type",
  },
  [SymbilityErrorType.COMPANY_ID_NOT_SUPPORTED]: {
    sentryDescription: "Company ID not supported",
  },
  [SymbilityErrorType.INVALID_EXTERNAL_ID]: {
    sentryDescription: "Invalid external ID",
  },
};

type Address = {
  addressStreet: string;
  city: string;
  zip: string;
  stateCode: StateType;
};
